module.exports = __webpack_public_path__ + "media/images/common/h3_search-eeb4f80931fb667950cc64ba11357dba.gif";